<template>
  <div id="app">
    <HeaderComponent
      ref="menu"
      data-theme=""
      data-position=""
    />

    <main class="app__container">
      <transition
        @enter="enter"
        @leave="leave"
        :appear="true"
      >
        <router-view :key="$route.fullPath"/>
      </transition>
    </main>
  </div>
</template>

<script>
import loop from '@/scripts/loop';
import initialStates from '@/scripts/initialStates';
import animations from '@/scripts/animations';
import { qsa } from '@/scripts/utils';

import HeaderComponent from '@/components/HeaderComponent.vue';
import {
  TweenMax,
  TimelineMax,
  AttrPlugin,
  CSSPlugin,
} from 'gsap/all';

const activated = [
  TweenMax,
  TimelineMax,
  AttrPlugin,
  CSSPlugin,
];


export default {
  name: 'App',

  components: {
    HeaderComponent,
  },
  data() {
    return {
      loopIsRunning: false,
      prevPageY: 0,
    };
  },

  mounted() {
    console.log(activated);
    loop.start();
    loop.add(() => this.checkBgMenu(), 'check-menu');
  },

  methods: {
    checkBgMenu() {
      if (window.pageYOffset
        > (window.innerHeight - this.$refs.menu.$el.getBoundingClientRect().height)) {
        this.$refs.menu.$el.setAttribute('data-theme', 'white');
      } else {
        this.$refs.menu.$el.setAttribute('data-theme', 'transparent');
      }

      if (window.pageYOffset > this.prevPageY && window.pageYOffset
        > (window.innerHeight - this.$refs.menu.$el.getBoundingClientRect().height)) {
        this.$refs.menu.$el.setAttribute('data-position', 'hidden');
      } else if (window.pageYOffset < this.prevPageY) {
        this.$refs.menu.$el.setAttribute('data-position', 'visible');
      }

      this.prevPageY = window.pageYOffset;
    },

    initializeAnimations(ctx, callback) {
      const label = `animations-${ctx.getAttribute('data-page')}`;
      const els = qsa('[data-anim]', ctx);

      if (els.length > 0) {
        const elsToSet = [];

        els.forEach((el) => {
          const obj = this.createObjToAnimate(el);
          elsToSet.push(obj);

          initialStates.get(obj.animation)(obj);
        });

        const handlerAnimations = () => this.addAnimationsPage(elsToSet, label);
        loop.add(handlerAnimations, label, true);

        if (loop.stopped) loop.start();
        this.loopIsRunning = true;
      }

      callback();
    },

    createObjToAnimate(el) {
      const obj = {
        node: el,
        initFromTop: el.getBoundingClientRect().top,
        fromTop() {
          return this.node.getBoundingClientRect().top;
        },
        height: el.getBoundingClientRect().height,
        animation: el.getAttribute('data-anim'),
        isAnimated: false,
        isVisible: false,
        splitted: false,
      };

      return obj;
    },

    addAnimationsPage(els, label) {
      els.forEach((el, i) => {
        if (!el.isAnimated && el.fromTop() < (window.innerHeight - 150)) {
          el.isAnimated = true; // eslint-disable-line
          el.isVisible = true; // eslint-disable-line

          animations.get(el.animation)(el);
        } else if (el.isVisible
          && ((el.fromTop() + el.height) < 0 || el.fromTop() > window.innerHeight)) {
          el.isVisible = false; // eslint-disable-line

          if (els.length === 1) {
            loop.remove(label);
            this.loopIsRunning = false;
          }

          if (el.splitted) el.instance.revert();
          els.splice(i, 1);
        }
      });
    },

    enter(el, done) {
      this.initializeAnimations(el, done);
    },

    leave(el, done) {
      const page = el.getAttribute('data-page');
      if (this.loopIsRunning) loop.remove(`add-animation-${page}`);

      done();
    },
  },
};
</script>

<style lang="scss">
@import './main';

.c-container {
  position: relative;
  width: 100%;
  margin: 0 auto;

  &--big,
  &--small {
    @include mq(ipadP) {
      max-width: 740px;
    }

    @include mq(ipadL) {
      max-width: 960px;
    }

    @include mq(ds) {
      max-width: 1080px;
    }

    @include mq(d) {
      max-width: 1280px;
    }

    @include mq(dl) {
      max-width: 1680px;
    }

    @include mq(dxl) {
      max-width: 1920px;
    }
  }

  &--big {
    @include mq($until: ipadP) {
      width: calc(100% - 40px);
      margin: 0 20px;
    }
  }

  &--small {
    padding: 0 20px;

    @include mq(mobileX) {
      padding: 0 40px;
    }

    @include mq(ipadL) {
      padding: 0 80px;
    }

    @include mq(d) {
      padding: 0 120px;
    }
  }
}

input, textarea, select {
  font-family: $font-family-text;
}

.c-hidden {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
}
</style>
